import { Routes, Route } from "react-router-dom";
import Kit_Pdf from "./Components/Kit_Pdf";
import Home from "./Components/Home";
import QrGenerator from "./Components/QrGenerator";
import EmailGenerator from "./Components//EmailGenerator";

function App() {
  return (
   
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pdf" element={<Kit_Pdf />} />
        <Route path="/qr_generator" element={<QrGenerator />} />
        <Route path="/email_generator" element={<EmailGenerator />} />
      </Routes>
    
  );
}

export default App;